//#region Util Imports

import * as _ from 'underscore'
import * as moment from 'moment'
import { locale as globalizeLocale, formatNumber as globalizeFormatNumber, parseNumber as globalizeParseNumber } from 'globalize'

//#endregion

//#region Angular Imports

import { IServiceProvider } from "angular"
import { Language } from './system.service.interfaces'
import { ConfigHelper } from '../../helpers'
import { Enums } from '../../models/common'

//#endregion

// #region Public Types

export const SYSTEM_INTERNATIONALIZATION_SERVICE_NAME = 'SystemInternationalizationService'
export const SYSTEM_INTERNATIONALIZATION_PROVIDER_NAME = 'SystemInternationalizationServiceProvider'

//#endregion

//#region Date Types

export class Week {

    //#region Members

    private days: Day[] = []

    //#endregion

    public constructor() {
        const short: Record<string, string> = globalizeLocale().main('dates/calendars/gregorian/days/format/short')

        for (const prop in short) {
            const day: Day = new Day(prop)

            this.days.push(day)
        }
    }

    public getDays(): ReadonlyArray<Day> {
        return this.days
    }
}

export class Day {

    //#region Members

    private longName: string
    private shortName: string
    private dayNumber: number

    //#endregion

    //#region Ctor

    public constructor(dayName: string) {
        const short: Record<string, string> = globalizeLocale().main('dates/calendars/gregorian/days/format/short')
        const wide: Record<string, string> = globalizeLocale().main('dates/calendars/gregorian/days/format/wide')

        this.dayNumber = _.indexOf(_.keys(short), dayName)
        this.shortName = short[dayName]
        this.longName = wide[dayName]
    }

    //#endregion

    public getDayNumber(): number {
        return this.dayNumber
    }

    public getName(): string {
        return this.longName
    }

    public getShortName(): string {
        return this.shortName
    }
}

export class Formatter {

    public formatDate(value: Date, format: string): string {
        if (value != null) {
            return moment(value).format(this.getFormatForMoment(format))
        }

        return null
    }

    private getFormatForMoment(dateFormat: string) {
        let result: string = dateFormat

        if (result != null) {
            result = result.replace(/z/g, 'Z')
            result = result.replace(/y/g, 'Y')
            result = result.replace(/dddd/g, '****')
            result = result.replace(/ddd/g, '***')
            result = result.replace(/d/g, 'D')
            result = result.replace(/\*/g, 'd')
            result = result.replace(/f/g, 'S')
            // result = result.replace(/A/g, 'a')
            result = result.replace(/a/g, 'A')
            result = result.replace(/tt/g, 'A')
        }

        return result
    }

    public formatNumber(value: number, globalizeOptions: any = null): string {
        if (value != null) {
            return globalizeFormatNumber(value, globalizeOptions || {})
        }

        return null
    }
}

export class Parser {
    parseNumber(value: string): number {
        if (value != null) {
            return globalizeParseNumber(value)
        }

        return null
    }
}


//#endregion

export class SystemInternationalizationService {

    //#region Consts

    private get LOG_PREFIX(): string { return '[SIMAX.Services.SystemInternationalization]' }

    //#endregion


    //#region Date

    public getFormatter(): Formatter {
        return new Formatter()
    }

    public getParser(): Parser {
        return new Parser()
    }

    public getWeek(): Week {
        return new Week()
    }

    //#endregion


    //#region Number

    public getDecimalSeparator(): string {
        return globalizeLocale().main('numbers/symbols-numberSystem-latn/decimal')
    }

    //#endregion

    //#region Languages

    public getLanguages(): ReadonlyArray<Language> {
        return ConfigHelper.getSectionValue(Enums.SimaxConfigSection.Languages)
    }

    //#endregion
}

export class SystemInternationalizationServiceProvider implements IServiceProvider {

    // #region IServiceProvider Implementation 

    public $get = [() => {
        return new SystemInternationalizationService()
    }]

    // #endregion
} 